import { Component, Input, Output, OnDestroy, OnInit } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { FormControl, FormControlDirective, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { debounceTime, map } from "rxjs/operators";
import { switchMap, take, takeUntil } from "rxjs/operators";
import { ApiService } from "../../../services/api.service";
import { CommuteService } from "../../../services/commute.service";
import { LoaderService } from "../../../services/loader.service";
import { ConfigurationService } from "../../../services/configuration.service";
import { ToastService } from "mis-crystal-design-system/toast";
import { ValueConverter } from "@angular/compiler/src/render3/view/template";
import { BookingDataService } from "../../../services/booking-data.service";
import * as moment from "moment";
import { DropdownItem } from "mis-crystal-design-system/dropdown";
import { DrawerService } from "mis-design-system/drawer";
import { VehicleCreateFormComponent } from "../vehicle-create-form/vehicle-create-form.component";
import { CookieService } from "../../../services/cookie.service";
import { EmpUserService } from "../../../services/emp-user.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "[mis-employee-web-exp-parking]",
  templateUrl: "./parking.component.html",
  styleUrls: ["./parking.component.scss"]
})
export class ParkingComponent implements OnInit, OnDestroy {
  constructor(
    public commuteSvc: CommuteService,
    private loader: LoaderService,
    private configSvc: ConfigurationService,
    private toasts: ToastService,
    private bookingSvc: BookingDataService,
    private apiService: ApiService,
    private _drawerSvc: DrawerService,
    private _userServ: EmpUserService,
    private _translateSvc: TranslateService
  ) {
    this.parkingForm = this.buildForm();
  }
  readonly Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  premises: NsEmpWebExpData.IParkingPremise[] = [];
  premiseZones: NsEmpWebExpData.IParkingPremise[] = [];
  vehicles: NsEmpWebExpData.IParkingPremise[] = [];
  zones: NsEmpWebExpData.IParkingPremise[] = [];
  levels: NsEmpWebExpData.IParkingPremise[] = [];
  configs = this.configSvc.bookingConfigurations;
  parkingForm = undefined;
  private endObs = new Subject();
  enableParkingFloorPlan = false;
  enableWaitlistBooking: boolean;
  enableJoinAllWaitlist: boolean;
  noAvaliability: boolean = false;
  currLevel: NsEmpWebExpData.IParkingPremise;
  waitlist = new Set<NsEmpWebExpData.IParkingPremise>();
  allLevelChecked: boolean = false;
  oldList = new Set<NsEmpWebExpData.IParkingPremise>();
  parkingScheduleCutoff: number;
  bulkBookingParkingCutoff: boolean = false;
  maxDate: any;
  formattedMaxDate: any;
  autoSlotAllocate: boolean;
  vehicleCreationDuringParkingEnabled: boolean = false;
  vehicleCreationDuringParkingFor: Array<string> = [];
  vehcleInfo: NsEmpWebExpData.IVehicleDetails[] = [];
  vehicleDetailsInfo: DropdownItem[] = [];
  selectedVehicleDetails: DropdownItem = {
    label: "",
    value: ""
  };
  showLoader: boolean = false;
  isHybridParking: string = "true";
  userInfo: any = {
    buid: this._userServ.employeeInfo.buid,
    empGuid: this._userServ.employeeInfo.empGuid
  };

  ngOnInit(): void {
    this.commuteSvc.commuteDate.pipe(takeUntil(this.endObs)).subscribe(res => {
      let endDate: any = moment(res?.endTime);
      let startDate: any = moment(res?.startTime);
      let currDate: any = moment().startOf("day");

      let diff = Math.abs(currDate - startDate);
      let diffinDays = moment.duration(diff).asDays();

      this.parkingScheduleCutoff = this.bookingSvc.formConfiguration.userConfigs.flattenedSettings?.parkingScheduleCutoff;

      if (startDate - endDate != 0) {
        diff = Math.abs(endDate - startDate);
        diffinDays = moment.duration(diff).asDays();

        diffinDays > this.parkingScheduleCutoff ? (this.bulkBookingParkingCutoff = true) : (this.bulkBookingParkingCutoff = false);

        const today = moment().tz(this.bookingSvc?.timezone);
        this.maxDate = today.add(this.parkingScheduleCutoff, "days");
        this.formattedMaxDate = this.maxDate.format("MMM DD, YYYY");
      }
    });
    this.enableJoinAllWaitlist = this.bookingSvc.formConfiguration.userConfigs.flattenedSettings?.enableJoinAllWaitlist;
    this.enableWaitlistBooking =
      this.bookingSvc.formConfiguration.userConfigs.flattenedSettings?.enableWaitlistBooking && !this.commuteSvc.multipleDaysSelected;
    this.enableParkingFloorPlan = this.commuteSvc.enableGridFloorPlan;
    this.autoSlotAllocate = this.bookingSvc.formConfiguration.userConfigs.flattenedSettings?.autoSlotAllocate;
    this.vehicleCreationDuringParkingFor = this.bookingSvc.formConfiguration.userConfigs.flattenedSettings?.vehicleCreationDuringParkingFor;
    this.vehicleCreationDuringParkingEnabled = this.vehicleCreationDuringParkingFor.length > 0;
    this.parkingForm.controls.vehicle.valueChanges.subscribe(vehicleType => {
      if (vehicleType) this.commuteSvc.setAllotedParkingData({ vehicleType: vehicleType?.premiseType, zoneId: null, levelId: null, seatId: null });
    });
    this.vehicleCreationDuringParkingEnabled ? this.fetchVehicleDetails() : this.fetchParkingDetails();
  }

  fetchParkingDetails() {
    if (this.vehicleCreationDuringParkingEnabled) {
      this.loader.show();
      this.apiService
        .getParking(
          this.commuteSvc.parkingFormOfficeGuid,
          this.commuteSvc.parkingFormStartTime,
          this.commuteSvc.parkingFormEndTime,
          this.isHybridParking,
          this.commuteSvc.getEntityTypeId()
        )
        .pipe(takeUntil(this.endObs))
        .subscribe((res: any) => {
          this.premises = [...res];
          this.commuteSvc.parkingPremises.next([...res]);
          this.premiseZones = [...res.map(p => ({ ...p, label: p.parentPremiseName }))];
          const vehicleTypes = this.groupBy("premiseType", res);
          this.vehicles = Array.from(vehicleTypes.values()) as any;
          this.parkingForm.patchValue({ vehicle: this.vehicles[0] });
          this.commuteSvc.formData.pipe(take(1), debounceTime(100)).subscribe(([, , { login }]) => {
            if (login?.id === "parking") {
              const level = this.premises.find(prm => prm.premiseId === (login.value as NsEmpWebExpData.IParkingPremise).premiseId);
              if (level) {
                const vehicle = this.vehicles.find(prm => prm.premiseType === level.premiseType);
                !this.enableParkingFloorPlan && this.setZones(vehicle);
                const zone = this.premiseZones.find(prm => prm.parentPremise === level.parentPremise);
                const parkingData: NsEmpWebExpData.IAllotedParkingDetails = {
                  vehicleType: zone.premiseType,
                  zoneId: level.parentPremise,
                  levelId: level.premiseId
                };
                this.commuteSvc.setAllotedParkingData(parkingData);
                !this.enableParkingFloorPlan && this.setLevels(zone);
                this.parkingForm.patchValue({ vehicle, zone, level }, { emitEvent: false, onlySelf: true });
                const opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?, string?, string?] = [
                  { id: "parking", value: level, disable: false },
                  undefined,
                  this.commuteSvc.selectedVehicleRegNo,
                  this.commuteSvc.entityTypeId,
                  this.commuteSvc.vehicleId
                ];
                if (this.configSvc.isMobile) {
                  this.commuteSvc.temporaryCommuteSelection = opt;
                  return;
                }
                this.commuteSvc.setCommute(opt);
              }
            }
            if (login?.id === "parkingWaitlist" && login?.value && login?.value.length) {
              if (!this.enableParkingFloorPlan) {
                const waitlistIds = new Set(login.value);
                const waitlistPremises = this.premises.filter(premise => waitlistIds.has(premise.premiseId));
                // const vehicle = this.vehicles.find(prm => prm.premiseType === waitlistPremises[0]?.premiseType);
                // const zone = this.premiseZones.find(prm => prm.parentPremise === waitlistPremises[0]?.parentPremise);
                // const level = this.premises.find(prm => prm.premiseId === waitlistPremises[0]?.premiseId)
                // this.parkingForm.patchValue({ vehicle, zone, level }, { emitEvent: false, onlySelf: true });
                this.waitlist = new Set(waitlistPremises);
                this.allLevelChecked = false;
              } else {
                try {
                  this.waitlist = new Set(JSON.parse(localStorage.getItem("waitingPremiseIds")));
                } catch (err) {
                  this.waitlist = new Set();
                }
              }
              this.sendWaitlist();
            }
          });
          this.loader.hide();
        });
    } else {
      this.commuteSvc.parkingRefreshStream
        .pipe(
          takeUntil(this.endObs),
          switchMap(obs => {
            this.loader.show();
            return obs;
          })
        )
        .subscribe(res => {
          this.premises = [...res];
          this.commuteSvc.parkingPremises.next([...res]);
          this.premiseZones = [...res.map(p => ({ ...p, label: p.parentPremiseName }))];
          const vehicleTypes = this.groupBy("premiseType", res);
          this.vehicles = Array.from(vehicleTypes.values());
          this.parkingForm.patchValue({ vehicle: this.vehicles[0] });
          this.commuteSvc.formData.pipe(take(1), debounceTime(100)).subscribe(([, , { login }]) => {
            if (login?.id === "parking") {
              const level = this.premises.find(prm => prm.premiseId === (login.value as NsEmpWebExpData.IParkingPremise).premiseId);
              if (level) {
                const vehicle = this.vehicles.find(prm => prm.premiseType === level.premiseType);
                !this.enableParkingFloorPlan && this.setZones(vehicle);
                const zone = this.premiseZones.find(prm => prm.parentPremise === level.parentPremise);
                const parkingData: NsEmpWebExpData.IAllotedParkingDetails = {
                  vehicleType: zone.premiseType,
                  zoneId: level.parentPremise,
                  levelId: level.premiseId
                };
                this.commuteSvc.setAllotedParkingData(parkingData);
                !this.enableParkingFloorPlan && this.setLevels(zone);
                this.parkingForm.patchValue({ vehicle, zone, level }, { emitEvent: false, onlySelf: true });
                const opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?] = [
                  { id: "parking", value: level, disable: false },
                  undefined
                ];
                if (this.configSvc.isMobile) {
                  this.commuteSvc.temporaryCommuteSelection = opt;
                  return;
                }
                this.commuteSvc.setCommute(opt);
              }
            }
            if (login?.id === "parkingWaitlist" && login?.value && login?.value.length) {
              if (!this.enableParkingFloorPlan) {
                const waitlistIds = new Set(login.value);
                const waitlistPremises = this.premises.filter(premise => waitlistIds.has(premise.premiseId));
                // const vehicle = this.vehicles.find(prm => prm.premiseType === waitlistPremises[0]?.premiseType);
                // const zone = this.premiseZones.find(prm => prm.parentPremise === waitlistPremises[0]?.parentPremise);
                // const level = this.premises.find(prm => prm.premiseId === waitlistPremises[0]?.premiseId)
                // this.parkingForm.patchValue({ vehicle, zone, level }, { emitEvent: false, onlySelf: true });
                this.waitlist = new Set(waitlistPremises);
                this.allLevelChecked = false;
              } else {
                try {
                  this.waitlist = new Set(JSON.parse(localStorage.getItem("waitingPremiseIds")));
                } catch (err) {
                  this.waitlist = new Set();
                }
              }
              this.sendWaitlist();
            }
          });
          this.loader.hide();
          this.showLoader = false;
        });
    }
    if (!this.enableParkingFloorPlan) {
      this.listenFormChanges();
    }
    if (this.vehicleCreationDuringParkingEnabled) {
      const opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?, string?, string?] = [
        this.parkingForm.value.level
          ? {
              id: "parking",
              value: {
                premise: this.parkingForm?.value?.level?.premise,
                premiseId: this.parkingForm?.value?.level?.premiseId, //level
                seatId: this.parkingForm?.value?.seatId, //token
                seatName: this.parkingForm?.value?.seatName,
                premiseType: this.parkingForm?.value?.level?.premiseType
              },
              disable: false
            }
          : undefined,
        undefined,
        this.commuteSvc.selectedVehicleRegNo,
        this.commuteSvc.entityTypeId,
        this.commuteSvc.vehicleId
      ];
      if (this.configSvc.isMobile) {
        this.commuteSvc.temporaryCommuteSelection = opt;
        return;
      }
      this.commuteSvc.setCommute(opt);
    } else {
      this.commuteSvc.regNo.valueChanges.pipe(takeUntil(this.endObs)).subscribe(res => {
        if (res !== undefined && res !== null) {
          const opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?] = [
            this.parkingForm.value.level
              ? {
                  id: "parking",
                  value: {
                    premise: this.parkingForm?.value?.level?.premise,
                    premiseId: this.parkingForm?.value?.level?.premiseId, //level
                    seatId: this.parkingForm?.value?.seatId, //token
                    seatName: this.parkingForm?.value?.seatName,
                    premiseType: this.parkingForm?.value?.level?.premiseType
                  },
                  disable: false
                }
              : undefined,
            undefined,
            res
          ];
          if (this.configSvc.isMobile) {
            this.commuteSvc.temporaryCommuteSelection = opt;
            return;
          }
          this.commuteSvc.setCommute(opt);
        }
      });
    }
    // this.parkingForm.get("vehicle").valueChanges.subscribe(typeChange => {
    //   if(typeChange){
    //     this.commuteSvc.regNo.patchValue("");
    //   }
    // })
    this.commuteSvc.removeCommute.pipe(takeUntil(this.endObs)).subscribe(res => {
      if (this.enableParkingFloorPlan) {
        return;
      }
      this.allLevelChecked = false;
      this.waitlist.delete(this.premises.find(premise => premise.premiseId === res));
      this.sendWaitlist();
    });
  }

  fetchVehicleDetails() {
    this.showLoader = true;
    this.apiService.getVehicleDetails(this.userInfo.buid, this.userInfo.empGuid).subscribe({
      next: (res: NsEmpWebExpData.IVehicleDetails[]) => {
        if (!!res) {
          this.vehcleInfo = res.length > 0 ? res : [];
          this.vehicleDetailsInfo =
            res.length > 0
              ? res.map((item: any) => {
                  return {
                    label: item.name,
                    value: item.id
                  };
                })
              : [];
          if (!!this.commuteSvc.vehicleId && this.vehcleInfo.length > 0) {
            let prevVehicleDetails = this.vehcleInfo.filter((item: NsEmpWebExpData.IVehicleDetails) => {
              return item.id === this.commuteSvc.vehicleId;
            });
            this.selectedVehicleDetails =
              prevVehicleDetails.length > 0
                ? {
                    label: prevVehicleDetails[0]?.name,
                    value: prevVehicleDetails[0]?.id
                  }
                : this.selectedVehicleDetails;
            this.commuteSvc.setEntityTypeId(prevVehicleDetails.length > 0 ? prevVehicleDetails[0]?.build : "");
            this.commuteSvc.entityType = prevVehicleDetails.length > 0 ? prevVehicleDetails[0]?.type : "";
            this.commuteSvc.vehicleId = prevVehicleDetails.length > 0 ? prevVehicleDetails[0]?.id : "";
            this.commuteSvc.selectedVehicleRegNo = prevVehicleDetails.length > 0 ? prevVehicleDetails[0]?.number : "";
          } else {
            this.selectedVehicleDetails =
              this.vehicleDetailsInfo.length > 0 ? (this.vehicleDetailsInfo[0] as DropdownItem) : this.selectedVehicleDetails;
            this.commuteSvc.setEntityTypeId(this.vehcleInfo.length > 0 ? this.vehcleInfo[0].build : "");
            this.commuteSvc.entityType = this.vehcleInfo.length > 0 ? this.vehcleInfo[0].type : "";
            this.commuteSvc.vehicleId = this.vehcleInfo.length > 0 ? this.vehcleInfo[0].id : "";
            this.commuteSvc.selectedVehicleRegNo = this.vehcleInfo.length > 0 ? this.vehcleInfo[0].number : "";
          }
          this.vehicleDetailsInfo.length > 0 && this.fetchParkingDetails();
        } else {
          this.toasts.displayMsg(`${this._translateSvc.instant("Unable to fetch Vehicle Details")}`, 2000);
        }
        this.showLoader = false;
      },
      error: () => {
        this.showLoader = false;
        this.toasts.displayMsg(`${this._translateSvc.instant("Unable to fetch Vehicle Details")}`, 2000);
      }
    });
  }

  setVehicleDetails(event) {
    this.selectedVehicleDetails = event;
    let selectedVDetails = this.vehcleInfo.filter((item: NsEmpWebExpData.IVehicleDetails) => {
      return item.id === event.value;
    });
    this.commuteSvc.removeParking.next(true);
    this.commuteSvc.setEntityTypeId(selectedVDetails.length > 0 ? selectedVDetails[0]?.build : "");
    this.commuteSvc.entityType = selectedVDetails.length > 0 ? selectedVDetails[0]?.type : "";
    this.commuteSvc.vehicleId = selectedVDetails.length > 0 ? selectedVDetails[0]?.id : "";
    this.commuteSvc.selectedVehicleRegNo = selectedVDetails.length > 0 ? selectedVDetails[0]?.number : "";
    this.showLoader = true;
    setTimeout(() => {
      this.fetchParkingDetails();
      this.showLoader = false;
    }, 10);
  }

  ngOnDestroy(): void {
    this.commuteSvc.removeLocalStorage();
    this.endObs.next();
    this.endObs.complete();
  }

  setSlot(data: NsEmpWebExpData.IParkingPremise): void {
    this.parkingForm.patchValue({
      seatId: data.seatId,
      seatName: data.seatName,
      level: { premiseId: data.premiseId, premise: data.premise, premiseType: data?.premiseType },
      regNo: this.commuteSvc.regNo.value
    });
    let opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?, string?, string?];
    if (this.vehicleCreationDuringParkingEnabled) {
      opt = [
        this.parkingForm.value.level ? { id: "parking", value: data, disable: false } : undefined,
        undefined,
        this.commuteSvc.selectedVehicleRegNo,
        this.commuteSvc.entityTypeId,
        this.commuteSvc.vehicleId
      ];
    } else {
      opt = [this.parkingForm.value.level ? { id: "parking", value: data, disable: false } : undefined, undefined, this.parkingForm.value.regNo];
    }
    this.commuteSvc.setCommute(opt);
  }

  private listenFormChanges(): void {
    const vehicleCtrl = this.parkingForm.get("vehicle");
    const zoneCtrl = this.parkingForm.get("zone");
    let regNo = this.vehicleCreationDuringParkingEnabled ? this.commuteSvc.selectedVehicleRegNo : "";
    vehicleCtrl.valueChanges.pipe(takeUntil(this.endObs)).subscribe(type => {
      this.setZones(type);
      this.commuteSvc.regNo.patchValue(regNo);
      this.allLevelChecked = false;
    });
    zoneCtrl.valueChanges.pipe(takeUntil(this.endObs)).subscribe(type => {
      this.setLevels(type);
    });
  }

  private groupBy<T>(key: string, arr: T[]): Map<string, T> {
    const res = new Map();
    for (const item of arr) {
      if (!res.has(item[key])) {
        res.set(item[key], item);
      }
    }
    return res;
  }

  private buildForm(): FormGroup {
    const form = new FormGroup({
      vehicle: new FormControl({}, [Validators.required]),
      regNo: new FormControl("", []),
      zone: new FormControl(undefined, [Validators.required]),
      level: new FormControl(undefined, [Validators.required]),
      slot: new FormControl(undefined, []),
      seatId: new FormControl(undefined, []),
      seatName: new FormControl(undefined, [])
    });
    return form;
  }

  private setZones(type: NsEmpWebExpData.IParkingPremise): void {
    this.zones = Array.from(this.groupBy("parentPremise", this.premiseZones)?.values())
      .filter(premise => premise.premiseType === type?.premiseType)
      .sort((a, b) => a.parentPremiseName.localeCompare?.(b.parentPremiseName));
    this.setPremise("zone", this.zones[0]);
  }

  private setLevels(type: NsEmpWebExpData.IParkingPremise): void {
    this.levels = this.premises.filter(premise => premise.parentPremise === type?.parentPremise).sort((a, b) => a.premise.localeCompare?.(b.premise));
    let level = this.levels.filter(level => level.availability > 0)[0];
    if (!level) level = this.levels[0];
    this.setPremise("level", level);
  }

  setPremise(ctrl: string, value: NsEmpWebExpData.IParkingPremise, internal = true): void {
    this.parkingForm.patchValue({ [ctrl]: value });
    if (ctrl === "level") {
      this.currLevel = value;
      if (this.enableWaitlistBooking && value?.availability === 0) {
        this.setLevelV2(value, false);
        this.noAvaliability = true;
      } else {
        this.allLevelChecked = false;
        this.setLevelV2(value, false);
      }
    }
  }

  private setLevelV2(value: NsEmpWebExpData.IParkingPremise, internal: boolean): void {
    if (internal) return;
    this.noAvaliability = false;
    if (value.availability < 1) {
      if (this.enableWaitlistBooking) {
        this.noAvaliability = true;
        this.sendWaitlist();
      } else {
        this.toasts.displayMsg(`${this._translateSvc.instant("Parking slots are not available!")}`, 2000);
        return;
      }
    } else {
      // if(this.waitlist.size === 0)
      this.waitlist.clear();
      let opt: [NsEmpWebExpData.ICommuteOption?, NsEmpWebExpData.ICommuteOption?, string?, string?, string?];
      if (this.vehicleCreationDuringParkingEnabled) {
        opt = [
          value ? { id: "parking", value, disable: false } : undefined,
          undefined,
          this.commuteSvc.selectedVehicleRegNo,
          this.commuteSvc.entityTypeId,
          this.commuteSvc.vehicleId
        ];
      } else {
        opt = [value ? { id: "parking", value, disable: false } : undefined, undefined, this.commuteSvc.regNo.value];
      }
      if (this.configSvc.isMobile) {
        this.commuteSvc.temporaryCommuteSelection = opt;
        return;
      }
      this.commuteSvc.setCommute(opt);
    }
  }
  sendWaitlist(commute?: NsEmpWebExpData.ICommuteOption): void {
    !this.vehicleCreationDuringParkingEnabled
      ? this.commuteSvc.setCommute([
          { id: "parkingWaitlist", value: commute || Array.from(this.waitlist), disable: false },
          undefined,
          this.commuteSvc.regNo.value
        ])
      : this.commuteSvc.setCommute([
          { id: "parkingWaitlist", value: commute || Array.from(this.waitlist), disable: false },
          undefined,
          this.commuteSvc.selectedVehicleRegNo,
          this.commuteSvc.entityTypeId,
          this.commuteSvc.vehicleId
        ]);
  }

  joinWaitlist(event) {
    if (event.checked) {
      this.waitlist.add(this.currLevel);
      this.sendWaitlist();
    } else {
      this.allLevelChecked = false;
      this.waitlist.delete(this.currLevel);
      this.sendWaitlist();
    }
  }
  joinAllWaitlist(event) {
    if (event.checked) {
      this.allLevelChecked = true;
      this.waitlist = new Set(
        ...[
          this.premises.filter(premise => premise.premiseType === this.parkingForm.value.vehicle.premiseType).filter(zone => zone.availability === 0),
          Array.from(this.waitlist)
        ]
      );
      this.sendWaitlist();
    } else {
      this.waitlist.clear();
      this.sendWaitlist();
      this.allLevelChecked = false;
    }
  }

  openVehicleForm() {
    const userData = this.userInfo;
    const ref = this._drawerSvc.show(VehicleCreateFormComponent, userData);
    ref.afterClosed.subscribe({
      next: res => {
        if (res) {
          this.fetchVehicleDetails();
        }
      }
    });
  }
}
